import { useState, useContext, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

import Box from '@mui/material/Box';
import Avatar from '@mui/material/Avatar';
import Divider from '@mui/material/Divider';
import Popover from '@mui/material/Popover';
import { alpha } from '@mui/material/styles';
import MenuItem from '@mui/material/MenuItem';
import Typography from '@mui/material/Typography';
import IconButton from '@mui/material/IconButton';
import Collapse from '@mui/material/Collapse';

import { AuthContext } from '../../helper/context/auth/authContext';

import PersonIcon from '@mui/icons-material/Person';
import ChangeRoleModal from './roleChange';
import { getEmployeeList } from '../../helper/api/api';

// ----------------------------------------------------------------------



export default function AccountPopover() {
  
  const { logout, user } = useContext(AuthContext);
  const MENU_OPTIONS = [
    {
      label: 'Login activity',
  
      icon: 'eva:person-fill',
  
      path: '/login-activity'
    },
    {
      label: 'Personalization',
  
      icon: 'eva:person-fill',
  
      path: '/personalization'
    },
  
    // {
  
    //   label: 'Change Password',
  
    //   icon: 'eva:person-fill',
  
    // },
  
    // {
  
    //   label: 'Settings',
  
    //   icon: 'eva:settings-2-fill',
  
    // },
  
  ];
  
  const userData = user;
  
  let account = {};
  
  if (userData != null) {
  
    account = {
  
      displayName: userData ? userData[0]?.UserName : '',
  
      email: userData ? userData[0]?.Email : '',
  
      switchAcc: "SwitchAccount"
  
      // photoURL: '/assets/images/avatars/avatar_25.jpg',
  
    };
  
  }

  const [switchopen, switchsetOpen] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [profileImage, setProfileImage] = useState(null);

  const switchAcchandleClick = () => {

    switchsetOpen(!switchopen);

  };


  const [open, setOpen] = useState(null);
  const navigate = useNavigate();

  const handleOpen = (event) => {
    setOpen(event.currentTarget);
  };

  const handleClose = () => {
    setOpen(null);
  };

  const handleLogout = () => {
    logout();
  }
  const handleClick = (data) => {
    console.log("check", data);

    navigate(data?.path)
    setOpen(null);
  };

   const fetchData = () => {
    try {
      const params = {
        EmployeeNumber: user[0]?.EmployeeNumber,
        OU: user[0]?.OU,
        User: user[0]?.UserName,
        Role: user[0]?.Role
      };
      getEmployeeList(params)
        .then((response) => {
          console.log("API Response:", response);
          const profile = response?.data?.data?.[0]?.EmployeeProfile;
          setProfileImage(profile);
        })
        .catch((error) => {
          console.error("Error fetching data:", error);
        });
  
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);


  const handleSwitchAccount = (selectedAccount) => {
    if (!userData || !selectedAccount) {
      return;
    }

    const updatedUserInfo = [{
      FullName: selectedAccount.FullName,
      Role: selectedAccount.Role,
      UserID: userData[0]?.UserID,
      Username: userData[0]?.UserName,
      Email: userData[0]?.Email,
      EmployeeNumber: userData[0]?.EmployeeNumber || '',
      OU: userData[0]?.OU,
      MobileNumber: userData[0]?.MobileNumber,
      IsActive: true,
      token: userData[0]?.token
    }];
    try {
      localStorage.removeItem('userData');
      localStorage.setItem('userData', JSON.stringify(updatedUserInfo));
      window.location.reload(true);
    } catch (error) {
      console.error("Failed to update user data:", error);
    }
  };
  const userMapping = JSON.parse(localStorage.getItem('userSwitchData'));

  return (
    <>
      <IconButton
        onClick={handleOpen}
        sx={{
          width: 40,
          height: 40,
          background: (theme) => alpha(theme.palette.grey[500], 0.08),
          ...(open && {
            background: (theme) =>
              `linear-gradient(135deg, ${theme.palette.primary.light} 0%, ${theme.palette.primary.main} 100%)`,
          }),
        }}
      >
        <Avatar
          src={profileImage || (userData && userData.length > 0 && userData[0].EmployeeProfile ? userData[0].EmployeeProfile : '')}
          alt={userData && userData.length > 0 && userData[0].UserName ? userData[0].UserName : ''}
          sx={{
            width: 41,
            height: 41,
            border: (theme) => `solid 2px ${theme.palette.background.default}`,
          }}
        >
          {userData && userData.length > 0 && userData[0].UserName
            ? userData[0].UserName.charAt(0).toUpperCase()
            : ''}
        </Avatar>

      </IconButton>

      <Popover
        open={!!open}
        anchorEl={open}
        onClose={handleClose}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
        transformOrigin={{ vertical: 'top', horizontal: 'right' }}
        PaperProps={{
          sx: {
            p: 0,
            mt: 1,
            ml: 0.75,
            width: 200,
          },
        }}
      >
        <Box sx={{ my: 1.5, px: 2 }}>
          <Typography variant="subtitle2" noWrap>
            {account.displayName}
          </Typography>
          <Typography variant="body2" sx={{ color: 'text.secondary' }} noWrap>
            {account.email}
          </Typography>
          <Typography variant="body2" sx={{ color: 'text.secondary' }} onClick={() => navigate('/personalization')} noWrap>
            {account.personalization}
          </Typography>

        </Box>
        <Divider sx={{ borderStyle: 'dashed' }} />
        {MENU_OPTIONS.map((option, index) => (
          <>
            <MenuItem sx={{typography: 'body2'}} onClick={() => handleClick(option)}>
              {option.label}
            </MenuItem>
            {index < MENU_OPTIONS.length - 1 && (
              <Divider sx={{ borderStyle: 'dashed' }} />
            )}
          </>
        ))}
        <Divider sx={{ borderStyle: 'dashed', m: 0 }} />
        <MenuItem
          disableRipple
          disableTouchRipple
          onClick={() => setIsModalOpen(true)}
          sx={{ typography: 'body2', color: '', gap: 4 }}
        >
          Change Role
        </MenuItem>
        <Collapse in={switchopen} timeout="auto" unmountOnExit>
          <Box sx={{ pl: 1 }}>
            {userMapping?.map((option, index) => (
              <MenuItem
                key={index}
                onClick={() => handleSwitchAccount(option)}
                sx={{
                  display: 'flex',
                  // alignItems: 'center',
                  gap: 1,  // Proper spacing between icon and text
                  py: 1,     // Balanced vertical padding
                  px: 2,     // Balanced horizontal padding
                }}
              >
                <PersonIcon fontSize="small" color="text.primary" sx={{ mr: 1 }} />
                <Typography variant="body2" component="span">
                  {option.RoleName}
                </Typography>
              </MenuItem>
            ))}
          </Box>
        </Collapse>

        <Divider sx={{ borderStyle: 'dashed', m: 0 }} />

        <MenuItem
          disableRipple
          disableTouchRipple
          onClick={handleLogout}
          sx={{ typography: 'body2', color: 'error.main', py: 1.5 }}
        >
          Logout
        </MenuItem>
      </Popover>
      <ChangeRoleModal open={isModalOpen} onClose={() => setIsModalOpen(false)} />
    </>
  );
}
